// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const IncidentIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M12 5.75A6.25 6.25 0 0 1 18.25 12v1.25a.75.75 0 0 1-.75.75h-11a.75.75 0 0 1-.75-.75V12A6.25 6.25 0 0 1 12 5.75"
        opacity=".5"
      />
      <path d="M5 15.5h14a1.25 1.25 0 0 1 0 2.5H5a1.25 1.25 0 0 1 0-2.5m7-14c.41 0 .75.34.75.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.41.34-.75.75-.75m8.3 3.26a.75.75 0 0 1 0 1.06l-1.06 1.06a.75.75 0 1 1-1.06-1.06l1.06-1.06a.75.75 0 0 1 1.06 0m-16.6 0a.75.75 0 0 1 1.06 0l1.06 1.06a.75.75 0 0 1-1.06 1.06L3.7 5.82a.75.75 0 0 1 0-1.06" />
    </g>
  </SvgIcon>
);

export default IncidentIcon;
